import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal, useResource } from "@/comn/hooks";
import { BASE, APIS, SF_APC_MGMT_SRCH, SG_APC_MGMT_LST } from "./services/ComnCdService";
import { Link } from "react-router-dom";
export const ApcCodeList = (props: any) => {
    /*
     * APC Management
     * !== APC 관리 목록 조회 ==!
     */
    const pgeUid = "UI-CLRI-0402-004Q"; // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /**
     * Apc Management Form
     * !==폼 정의 ==!
     */
    const form = {
        //Apc Code Search !== Apc 코드 검색 ==!
        apcSrch: useForm({
            defaultSchema: SF_APC_MGMT_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    /*
     * Apc Management Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Apc Code List !== Apc 코드 목록 ==!
        apcList: useGrid({
            defaultSchema: SG_APC_MGMT_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * APC Management Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get APC Code List !== APC 코드 목록 조회 ==!
        getApcList: useFetch({
            api: (page = grid.apcList.page) => {
                form.apcSrch.setValue("useYn", "Y");
                return APIS.getApcMgmtList(form.apcSrch.getValues(), page, grid.apcList.size);
            },
            enabled: true,
            key: [grid.apcList.page, grid.apcList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.apcSrch.getValues(),
                    page: grid.apcList.page,
                    size: grid.apcList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * APC Management Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        //Get APC Code List !== APC 코드 목록 조회 ==!
        getApcList: (page: number = 0) => {
            form.apcSrch.handleSubmit(
                (data) => {
                    fetch.getApcList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        grid_ApcList: {
            cell: {
                apcCd: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.apcDesc, rowData: rowValues });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    /*
     * APC Management Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {}, []);

    return (
        <>
            <Page title={t("T_APC_LST")} info={true}>
                <Group>
                    <Group.Body>
                        <form>
                            <Group.Section>
                                <Group.Row>
                                    {/* APC !== APC ==! */}
                                    <Group.Control {...form.apcSrch.schema.apcCd} />
                                    <Group.Control {...form.apcSrch.schema.apcDesc} />
                                </Group.Row>
                            </Group.Section>
                        </form>
                        <Layout direction="row">
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getApcList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>

                <Group>
                    <Group.Body>
                        <Grid
                            {...grid.apcList.grid}
                            data={fetch.getApcList.data?.apcMgmtList}
                            render={render.grid_ApcList}
                        />
                    </Group.Body>
                </Group>
            </Page>
        </>
    );
};
